//@flow
import React, { useState } from 'react';
import type { Neighbourhood, NeighbourhoodTypes } from 'types/project';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MediaQuery from 'react-responsive';
import { CallToAction } from 'components/atoms/callToAction';
import { SectionIntro } from 'components/atoms/sectionIntro';
import MapComponent from 'components/molecules/map';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { ListMapMobile } from 'components/molecules/listMapMobile';
import { ShareButton } from 'components/atoms/shareButton';
import { RouteNames } from 'router';
import { NeighbourhoodFilter } from 'components/templates/neighbourhoodFilter';
import { ProjectMapper } from 'mappers/project';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectActions } from 'modules/project/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type Props = {
  data: {
    data: {
      list: Array<Neighbourhood>,
      types: Array<NeighbourhoodTypes>,
      project: {},
    },
    updateMapView: () => void,
    mapView: boolean,
  },
  toggleNeighbourhoodFilter: () => void,
  filteredList: Array<Neighbourhood>,
  activeFilter: Object<NeighbourhoodTypes>,
};

const NeighbourhoodGuide = (props: Props) => {
  const { height } = useViewport();
  const { data, toggleNeighbourhoodFilter, filteredList, activeFilter } = props;
  const [showNeighbourhoodOverlay, setNeighbourhoodOverlay] = useState(false);
  const [neighborhoodMobileArray, isNeighborhoodMobileArray] = useState([
    { ...ProjectMapper.allNeighbourhoodFilter },
    ...data.data.types.map(type => ({ ...type, isActive: false })),
  ]);
  const handleClick = () => {
    console.log('');
  };
  const exploreNeighbourhood = showNeighbourhoodOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={data.data}
        types={data.data.types}
        theme={'light-theme'}
        type={'neighbourhood'}
        filteredNeighbourHood={filteredList}
        onClosePress={() => setNeighbourhoodOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: data ? data.breadcrumb : 'Homes',
            breadcrumbLink: RouteNames.homes,
          },
          {
            breadcrumbName: 'Neighbourhood Guide',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const toggleFilter = val => {
    const updatedArray = neighborhoodMobileArray.map(item => ({
      ...item,
      isActive: item.id === val.id,
    }));
    isNeighborhoodMobileArray(updatedArray);
    toggleNeighbourhoodFilter(val.id === 'all' ? null : val);
  };

  return (
    <div id={'neighbourhood-guide'}>
      <MediaQuery maxDeviceWidth={575.98}>
        <ListMapMobile
          data={{ list: filteredList }}
          list={filteredList}
          updateMapView={data.updateMapView}
          mapView={data.mapView}
          onClick={handleClick}
          pinLocation={data.data.project}
          objectFit={'contain'}
          type={'neighborhood'}
          types={data.data.types}
          fetchTitle={
            <h2 className={'neighbourhood-title'}>
              Neighbourhood <br /> Guide
            </h2>
          }
          filterType={'neighbourhood'}
          updateFilter={() => {}}
          filterContent={
            <NeighbourhoodFilter
              options={neighborhoodMobileArray}
              toggleFilter={toggleFilter}
              activeFilter={activeFilter && activeFilter}
            />
          }
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <div className={'neighborhood-guide-desktop'} style={{ height }}>
          <Row style={{ height: '100%' }}>
            <Col md={4}>
              <SectionIntro
                title={'Neighbourhood Guide'}
                description={
                  'Enjoy the convenience of urban living with well-developed social infrastructure like schools, hospitals, hotels, retail, dining and entertainment in close proximity to the project.'
                }
                callToAction={
                  <CallToAction
                    text={'Explore'}
                    onClick={e => setNeighbourhoodOverlay(true)}
                    mode={'dark'}
                    className={'browse-events-button'}
                  />
                }
              />
            </Col>
            <Col md={8}>
              <MapComponent
                mapStyles={'neighborhood-map'}
                data={data.data.list}
                type={'neighbourhood'}
                pinLocation={data.data.project}
                updateFilter={() => {}}
                types={data.data.types}
              />
            </Col>
          </Row>
        </div>
        {exploreNeighbourhood}
      </MediaQuery>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    filteredList: ProjectSelector.filteredNeighbourhoods(state),
    activeFilter: ProjectSelector.neighbourhoodActiveFilter(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleNeighbourhoodFilter } = ProjectActions;
  return bindActionCreators(
    {
      toggleNeighbourhoodFilter,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(NeighbourhoodGuide);

export default withRouter(connectedComponent);
